var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.069,
    height: 31.071,
    viewBox: "0 0 31.069 31.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-0.5 -0.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24862",
    "data-name": "\\u30D1\\u30B9 24862",
    d: "M26.745.941a1.494,1.494,0,0,0-2.125,0L13.205,12.356a1.508,1.508,0,0,0-.381.631L10.96,19.211a1.5,1.5,0,0,0,.381,1.493,1.477,1.477,0,0,0,1.062.441,1.6,1.6,0,0,0,.431-.06l6.224-1.864a1.508,1.508,0,0,0,.631-.381L31.1,7.425a1.5,1.5,0,0,0,0-2.125Z",
    transform: "translate(0.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24863",
    "data-name": "\\u30D1\\u30B9 24863",
    d: "M30.065,14.531a1.5,1.5,0,0,0-1.5,1.5V26.056a2.508,2.508,0,0,1-2.506,2.506H6.012a2.508,2.508,0,0,1-2.506-2.506V6.012A2.508,2.508,0,0,1,6.012,3.507H16.034a1.5,1.5,0,0,0,0-3.007H6.012A5.519,5.519,0,0,0,.5,6.012V26.056a5.519,5.519,0,0,0,5.512,5.512H26.056a5.519,5.519,0,0,0,5.512-5.512V16.034A1.5,1.5,0,0,0,30.065,14.531Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/editButton.82a85a8e912265414a4f651bd3755cec.svg";
export { ForwardRef as ReactComponent };